<template>
  <div class="wizard-footer">
    <div class="footer-buttons">
      <b-button
        v-if="currentStep > 1"
        variant="outline-secondary"
        @click="$emit('previous')"
      >
        <feather-icon icon="ChevronLeftIcon" size="16" />
        Atrás
      </b-button>
      
      <b-button
        variant="outline-secondary"
        @click="$emit('cancel')"
      >
        Cancelar
      </b-button>
      
      <b-button
        v-if="currentStep < 2"
        variant="primary"
        :disabled="!canGoNext"
        @click="$emit('next')"
      >
        Siguiente
        <feather-icon icon="ChevronRightIcon" size="16" />
      </b-button>
      
      <b-button
        v-if="currentStep === 2"
        variant="primary"
        @click="$emit('create')"
      >
        Crear Documento
        <feather-icon icon="FileTextIcon" size="16" />
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WizardFooter',
  props: {
    currentStep: {
      type: Number,
      required: true
    },
    canGoNext: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.wizard-footer {
  border-top: 1px solid #e0e0e0;
  padding: 1rem 1.5rem;
  background-color: #f8f9fa;
  margin: 0 -1rem -1rem -1rem;
  
  .footer-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    align-items: center;
    
    button {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  }
}

@media (max-width: 576px) {
  .wizard-footer {
    .footer-buttons {
      flex-direction: column-reverse;
      
      button {
        width: 100%;
        justify-content: center;
      }
    }
  }
}
</style>
